module.exports = __webpack_public_path__ + "img/arrow-right.f2021db8.svg";